export default __webpack_public_path__ + "static/media/copy.2cf8d8fe.svg";